import { Handle, type NodeProps } from "@xyflow/react";
import type { BinaryNodeData } from "@/types/decision-graph";
import {
  getDualHandleOffsetStyle,
  getHandlePositions,
} from "../utils/handle-positions";

export function BinaryNode({ data }: NodeProps) {
  const d = data as BinaryNodeData;
  const { isHorizontal, inputPosition, outputPosition } = getHandlePositions(
    d.layoutDirection
  );

  return (
    <div className="rounded-md border border-purple-300 bg-purple-50 px-3 py-2 text-xs shadow-sm min-w-[70px]">
      <Handle
        type="target"
        position={inputPosition}
        id="left"
        style={getDualHandleOffsetStyle(isHorizontal, "first")}
      />
      <Handle
        type="target"
        position={inputPosition}
        id="right"
        style={getDualHandleOffsetStyle(isHorizontal, "second")}
      />
      <div className="font-medium text-purple-700 text-[10px] mb-0.5">
        LOGIC
      </div>
      <div className="text-purple-900 font-mono text-center text-sm font-bold">
        {d.operator}
      </div>
      <Handle type="source" position={outputPosition} id="result" />
    </div>
  );
}
